// ============================================================
// Portada del aniversario: tarjetas desde la configuración,
// slider (flechas, puntos, deslizar, avance automático),
// estados de los botones según la fecha y panel de vista previa.
// ============================================================
import { cfg, estado, rango, fechaCorta, proximoDia, conAcento, escapar, rellenarTextos, reducido, ahora, simularFecha, fechaSimulada } from "./coco-aniv-nucleo.js";

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const ICONO_VOLTEAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M18 3v4h-4M6 21v-4h4"/></svg>';
const CORAZON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';

rellenarTextos();

// ---------- Tarjetas del calendario (se voltean) ----------
function textoEstado(item) {
  const e = estado(item);
  if (e === "activo") return item.soloDia != null ? "¡Hoy disponible!" : "Activo ahora";
  if (e === "hoy-no") { const d = proximoDia(item); return d ? `Próximo: viernes ${fechaCorta(d)}` : "Finalizado"; }
  if (e === "proximo") return `Empieza el ${fechaCorta(item.desde)}`;
  return "Finalizado";
}
function pintarCalendario() {
  const caja = $("[data-calendario]");
  if (!caja) return;
  caja.innerHTML = cfg.calendario.map((c, i) => {
    const e = estado(c);
    const detalle = (c.detalle || []).map((d) => `<li>${escapar(d)}</li>`).join("");
    const enlace = c.enlace && (e === "activo" || !c.soloDia) && e !== "finalizado" && e !== "proximo"
    ? `<a class="aniv-mini-btn" href="${escapar(c.enlace)}">${c.id === "mystery" ? "Ver la Mystery Box" : "Ver cómo funciona"} →</a>` : "";
    const comprar = c.comprar && e === "activo" ? `<a class="aniv-mini-btn aniv-comprar" href="${escapar(c.comprar)}">${escapar(c.comprarTexto || "Agregar al carrito")}</a>` : "";
    return `<article class="aniv-carta" data-anim style="--i:${i + 1}">
      <button class="aniv-voltear" type="button" aria-expanded="false" aria-label="${escapar(c.titulo)}: ver detalles"></button>
      <div class="aniv-carta-caras">
        <div class="aniv-cara frente">
          <span class="aniv-voltear-icono" aria-hidden="true">${ICONO_VOLTEAR}</span>
          <span class="aniv-carta-media"><img class="aniv-carta-img" src="${escapar(c.imagen)}" alt="" loading="lazy" style="--retraso:${-i * 1.3}s"></span>
          <div class="aniv-carta-cuerpo">
            <span class="aniv-chip">${escapar(c.etiqueta)}</span>
            <h3 class="aniv-carta-titulo">${escapar(c.titulo)}</h3>
            <p class="aniv-carta-texto">${escapar(c.texto)}</p>
            <span class="aniv-estado" data-estado="${e}">${escapar(textoEstado(c))}</span>
            ${comprar}
          </div>
        </div>
        <div class="aniv-cara dorso" aria-hidden="true">
          <span class="aniv-chip">${escapar(c.chip || c.etiqueta)}</span>
          <ul class="aniv-dorso-lista">${detalle}</ul>
          ${enlace}
        </div>
      </div>
    </article>`;
  }).join("");
  $$(".aniv-carta", caja).forEach((carta) => {
    const b = $(".aniv-voltear", carta);
    b.addEventListener("click", () => {
      const v = carta.classList.toggle("is-volteada");
      b.setAttribute("aria-expanded", String(v));
      $(".dorso", carta).setAttribute("aria-hidden", String(!v));
      $(".frente", carta).setAttribute("aria-hidden", String(v));
    });
  });
}

// ---------- Dinámicas por semana (botón según la fecha) ----------
function boton(d) {
  const e = estado(d);
  if (e === "activo") return `<a class="aniv-participar" data-estado="activo" href="${escapar(d.pagina)}">${CORAZON}Participar ahora</a>`;
  if (e === "proximo") return `<span class="aniv-participar" data-estado="proximo" role="link" aria-disabled="true">Próximamente · ${escapar(fechaCorta(d.desde))}</span>`;
  return `<span class="aniv-participar" data-estado="finalizado" role="link" aria-disabled="true">Finalizado</span>`;
}
function pintarSemanas() {
  const caja = $("[data-semanas]");
  if (!caja) return;
  caja.innerHTML = Object.values(cfg.dinamicas).map((d, i) => {
    const e = estado(d);
    return `<article class="aniv-carta ${e === "activo" ? "aniv-semana-activa" : ""}" data-anim style="--i:${i + 1}">
      <div class="aniv-carta-caras">
        <div class="aniv-cara frente">
          ${e === "activo" ? '<span class="aniv-insignia">Esta semana</span>' : ""}
          <span class="aniv-carta-media"><img class="aniv-carta-img" src="${escapar(d.imagen)}" alt="" loading="lazy" style="--retraso:${-i * 1.1}s"></span>
          <div class="aniv-carta-cuerpo">
            <span class="aniv-chip aniv-fechas">${escapar(rango(d.desde, d.hasta))}</span>
            <h3 class="aniv-carta-titulo">${escapar(d.nombre)}</h3>
            <p class="aniv-premios">${escapar(d.resumen)}</p>
            ${boton(d)}
          </div>
        </div>
      </div>
    </article>`;
  }).join("");
}

// ---------- Pasos ----------
function pintarPasos() {
  const caja = $("[data-pasos]");
  if (!caja) return;
  caja.innerHTML = cfg.pasos.map((p, i) => `<li class="aniv-paso" data-anim style="--i:${i + 1}">
      <span class="aniv-paso-circulo"><img src="${escapar(p.imagen)}" alt="" loading="lazy" style="--retraso:${-i * 0.9}s"><span class="aniv-paso-num">0${i + 1}</span></span>
      <h3 class="aniv-paso-titulo">${escapar(p.titulo)}</h3>
      <p class="aniv-paso-texto">${escapar(p.texto)}</p>
    </li>`).join("");
}

// Diapositiva 4: botón a la dinámica activa (o a la tienda si no hay ninguna)
function pintarPie() {
  const caja = $("[data-s4-pie]");
  if (!caja) return;
  const activa = Object.values(cfg.dinamicas).find((d) => estado(d) === "activo");
  caja.innerHTML = activa
    ? `<a class="aniv-participar" data-estado="activo" data-anim style="--i:5" href="${escapar(activa.pagina)}">${CORAZON}Participar: ${escapar(activa.nombre)} →</a>`
    : `<a class="aniv-participar" data-estado="activo" data-anim style="--i:5" href="${escapar(cfg.marca.tienda)}/collections/all">${CORAZON}Ver todas las joyitas →</a>`;
}

function pintarTodo() {
  pintarPie();
  pintarCalendario();
  pintarSemanas();
  pintarPasos();
  marcarEntradas();
}

// elementos de la diapositiva 1 que entran con escalonado
function marcarEntradas() {
  $$(".aniv-s1 .aniv-ante, .aniv-s1 .aniv-firma, .aniv-s1 .aniv-sello, .aniv-s1 .aniv-bajada, .aniv-s1 .aniv-pista, .aniv-cabeza > *").forEach((el, i, arr) => {
    if (!el.hasAttribute("data-anim")) { el.setAttribute("data-anim", ""); el.style.setProperty("--i", el.closest(".aniv-s1") ? i : arr.indexOf(el) % 3); }
  });
}

// ---------- Slider ----------
function iniciarSlider(raiz) {
  const pista = $("[data-track]", raiz);
  const slides = $$(".aniv-slide", pista);
  const dots = $("[data-dots]", raiz);
  const ms = cfg.slider?.autoavance ?? 8000;
  let actual = 0, temporizador = 0, pausaHasta = 0, visible = true;

  dots.innerHTML = slides.map((s, i) => `<button class="aniv-dot" type="button" role="tab" aria-label="Ir a la diapositiva ${i + 1}" aria-controls="${s.id}"></button>`).join("");
  const botonesDot = $$(".aniv-dot", dots);
  raiz.style.setProperty("--auto", ms + "ms");

  const ir = (i, suave = true) => {
    const n = (i + slides.length) % slides.length;
    pista.scrollTo({ left: slides[n].offsetLeft - pista.offsetLeft, behavior: suave && !reducido() ? "smooth" : "auto" });
  };
  const marcar = (i) => {
    if (i === actual && slides[i].classList.contains("is-activa")) return;
    actual = i;
    slides.forEach((s, k) => {
      s.classList.toggle("is-activa", k === i);
      s.setAttribute("aria-hidden", String(k !== i));
      s.inert = k !== i;
    });
    botonesDot.forEach((d, k) => d.setAttribute("aria-selected", String(k === i)));
    reiniciarAuto();
  };

  // progreso continuo del desplazamiento → profundidad (parallax) y diapositiva activa
  let tic = false;
  const alDesplazar = () => {
    tic = false;
    const ancho = pista.clientWidth || 1;
    let mejor = 0, dist = Infinity;
    slides.forEach((s, k) => {
      const p = (s.offsetLeft - pista.offsetLeft - pista.scrollLeft) / ancho;
      s.style.setProperty("--p", Math.max(-1, Math.min(1, p)).toFixed(3));
      if (Math.abs(p) < dist) { dist = Math.abs(p); mejor = k; }
    });
    if (dist < 0.5) marcar(mejor);
  };
  pista.addEventListener("scroll", () => { if (!tic) { tic = true; requestAnimationFrame(alDesplazar); } }, { passive: true });

  $("[data-prev]", raiz).addEventListener("click", () => { pausar(); ir(actual - 1); });
  $("[data-next]", raiz).addEventListener("click", () => { pausar(); ir(actual + 1); });
  botonesDot.forEach((d, k) => d.addEventListener("click", () => { pausar(); ir(k); }));
  $$("[data-ir]", raiz).forEach((b) => b.addEventListener("click", () => { pausar(); ir(+b.dataset.ir); }));
  pista.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") { e.preventDefault(); pausar(); ir(actual + 1); }
    if (e.key === "ArrowLeft") { e.preventDefault(); pausar(); ir(actual - 1); }
  });
  // si la persona toca, desliza o pasa el ratón, el avance automático espera
  ["pointerdown", "wheel", "touchstart", "focusin"].forEach((ev) => raiz.addEventListener(ev, () => pausar(), { passive: true }));
  raiz.addEventListener("mouseenter", () => pausar(4000));

  function pausar(t = 15000) {
    pausaHasta = Date.now() + t;
    raiz.classList.remove("is-auto");
    reiniciarAuto();
  }
  function reiniciarAuto() {
    clearTimeout(temporizador);
    if (!ms || reducido() || !visible || document.hidden) { raiz.classList.remove("is-auto"); return; }
    const espera = Math.max(0, pausaHasta - Date.now());
    if (espera) { temporizador = setTimeout(reiniciarAuto, espera); return; }
    raiz.classList.remove("is-auto");
    void raiz.offsetWidth; // reinicia la barrita de progreso del punto activo
    raiz.classList.add("is-auto");
    temporizador = setTimeout(() => ir(actual + 1), ms);
  }
  new IntersectionObserver(([e]) => {
    visible = e.isIntersecting;
    raiz.closest(".aniv-raiz")?.classList.toggle("aniv-pausa", !visible);
    reiniciarAuto();
  }, { threshold: 0.35 }).observe(raiz);
  document.addEventListener("visibilitychange", reiniciarAuto);
  addEventListener("resize", () => ir(actual, false));

  // inclinación suave del arte con el puntero (solo escritorio)
  const arte = $(".aniv-arte", raiz);
  if (arte && matchMedia("(hover: hover) and (pointer: fine)").matches && !reducido()) {
    const s1 = $(".aniv-s1", raiz);
    s1.addEventListener("pointermove", (e) => {
      const r = s1.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      arte.style.transform = `translateX(calc(var(--p) * -48px)) perspective(900px) rotateY(${(x * 8).toFixed(2)}deg) rotateX(${(-y * 6).toFixed(2)}deg)`;
    });
    s1.addEventListener("pointerleave", () => (arte.style.transform = ""));
  }

  slides[0].classList.remove("is-activa");
  requestAnimationFrame(() => { marcar(0); alDesplazar(); });
  return { ir, pausar, get actual() { return actual; } };
}

// ---------- Panel de vista previa: simular fecha ----------
function iniciarVistaPrevia() {
  const panel = $("[data-panel-previa]");
  if (!panel || !cfg.vistaPrevia?.permitirSimularFecha) return;
  panel.hidden = false;
  const btn = $("[data-abrir-previa]", panel), caja = $("[data-previa-panel]", panel);
  const etiqueta = $("[data-fecha-actual]", panel), input = $("[data-fecha-input]", panel);
  const d = cfg.dinamicas;
  const atajos = [
    ["Semana de la ruleta", d.ruleta.desde],
    ["Semana de la máquina", d.maquina.desde],
    ["Semana de las puertas", d.puertas.desde],
    ["Un viernes (Mystery Box)", "2026-10-16"],
    ["Antes del aniversario", "2026-09-28"],
    ["Ya terminó (noviembre)", "2026-11-03"],
  ];
  $("[data-atajos]", panel).innerHTML = atajos.map(([t, f]) => `<button type="button" data-f="${f}">${t} <small>(${fechaCorta(f)})</small></button>`).join("");
  const refrescar = () => {
    const f = fechaSimulada();
    etiqueta.textContent = f ? fechaCorta(f) : "hoy";
    input.value = f || "";
    $$("[data-f]", panel).forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.f === f)));
  };
  btn.addEventListener("click", () => { caja.hidden = !caja.hidden; btn.setAttribute("aria-expanded", String(!caja.hidden)); });
  panel.addEventListener("click", (e) => { const b = e.target.closest("[data-f]"); if (b) simularFecha(b.dataset.f); });
  input.addEventListener("change", () => input.value && simularFecha(input.value));
  $("[data-fecha-quitar]", panel).addEventListener("click", () => simularFecha(null));
  document.addEventListener("aniv:fecha", () => { refrescar(); pintarTodo(); });
  refrescar();
}

// ---------- arranque ----------
pintarTodo();
const raiz = $("[data-aniv-slider]");
if (raiz) window.anivSlider = iniciarSlider(raiz);
iniciarVistaPrevia();
// la franja de galletitas lleva a la página de cómo funciona
document.addEventListener("visibilitychange", () => document.querySelectorAll(".aniv-raiz").forEach((r) => r.classList.toggle("aniv-pausa", document.hidden)));
